import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export const monitorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const begin = performance.now();

  return next(request).pipe(
    finalize((): void => {
      const requestDuration = performance.now() - begin;
      if (requestDuration > 2000) {
        console.log(
          `HTTP ${request.method} %c${request.url} - %c${requestDuration.toFixed(2)} %c milliseconds`,
          'color: blue',
          'color: red',
          'color: black',
        );
      }
    }),
  );
};
